<!-- The calendar (E4 RF-43, plan AD-14): a Bootstrap month grid, no calendar library. Material Design Icons throughout. -->
<div class="card">
  <div class="card-body">
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
      <div class="d-flex align-items-center gap-2">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-outline-secondary" (click)="previous()" [attr.aria-label]="'task.range.previous' | translate">
            <i class="mdi mdi-chevron-left"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="today()">
            {{ 'task.range.today' | translate }}
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="next()" [attr.aria-label]="'task.range.next' | translate">
            <i class="mdi mdi-chevron-right"></i>
          </button>
        </div>
        <h5 class="header-title mb-0">{{ month | date: 'MMMM y' }}</h5>
      </div>
      @if (reading) {
        <span class="badge campaign-badge" [ngClass]="reading.overdueCount > 0 ? 'is-err' : 'is-ok'" [attr.aria-label]="'task.range.overdue' | translate: { count: reading.overdueCount }">
          <i class="mdi me-1" [ngClass]="reading.overdueCount > 0 ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline'"></i>
          {{ 'task.range.overdue' | translate: { count: reading.overdueCount } }}
        </span>
      }
    </div>

    @if (failed && !reading) {
      <div class="alert alert-danger py-2 mb-0" role="alert">
        <i class="mdi mdi-alert-circle-outline me-1"></i>{{ 'task.range.loadError' | translate }}
      </div>
    } @else if (loading && !reading) {
      <content-loading-list />
    } @else {
      <div class="task-calendar" role="grid">
        <div class="task-calendar__header" role="row">
          @for (weekday of weekdays; track $index) {
            <div class="task-calendar__weekday text-muted text-uppercase font-11 fw-bold" role="columnheader">
              {{ weekday | date: 'EEE' }}
            </div>
          }
        </div>
        <div class="task-calendar__grid" role="rowgroup">
          @for (cell of cells; track cell.day) {
            <button
              type="button"
              class="task-calendar__cell text-start"
              role="gridcell"
              [class.task-calendar__cell--muted]="!cell.inMonth"
              [class.task-calendar__cell--today]="cell.isToday"
              [class.task-calendar__cell--selected]="selectedDay === cell.day"
              [attr.aria-label]="'task.calendar.openDay' | translate: { day: (cell.date | date: 'd MMM') }"
              [attr.aria-pressed]="selectedDay === cell.day"
              (click)="select(cell)"
            >
              <span class="task-calendar__day fw-semibold">{{ cell.date | date: 'd' }}</span>
              @if (cell.open > 0) {
                <span class="d-block font-11 text-truncate">
                  <i class="mdi mdi-circle-outline me-1"></i>{{ 'task.calendar.open' | translate: { count: cell.open } }}
                </span>
              }
              @if (cell.concluded > 0) {
                <span class="d-block font-11 text-truncate text-success">
                  <i class="mdi mdi-check-circle-outline me-1"></i>{{ 'task.calendar.concluded' | translate: { count: cell.concluded } }}
                </span>
              }
            </button>
          }
        </div>
      </div>

      <hr class="my-3" />
      @if (selectedCell; as cell) {
        <h5 class="header-title d-flex align-items-center gap-2 mb-2">
          <i class="mdi mdi-calendar-today"></i>
          {{ 'task.calendar.dayTitle' | translate: { day: (cell.date | date: 'EEEE, d MMM') } }}
        </h5>
        <app-activity-list
          [activities]="cell.activities"
          [showResponsible]="!!reading?.responsible === false"
          timedFormat="HH:mm"
          dateFormat="DD/MM"
          (changed)="onChanged()"
        />
      } @else {
        <p class="text-muted font-13 mb-0">{{ 'task.calendar.pickDay' | translate }}</p>
      }
    }
  </div>
</div>
